import { render, staticRenderFns } from "./PermissionCard.vue?vue&type=template&id=2b4934d8&scoped=true&"
import script from "./PermissionCard.vue?vue&type=script&lang=js&"
export * from "./PermissionCard.vue?vue&type=script&lang=js&"
import style0 from "./PermissionCard.vue?vue&type=style&index=0&id=2b4934d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4934d8",
  null
  
)

export default component.exports